import { useTheme } from '@material-ui/core/styles';

export const createBreakpoints = () => {
  const theme = useTheme();

  return {
    UP_XS: theme.breakpoints.up('xs'),
    UP_SM: theme.breakpoints.up('sm'),
    UP_MD: theme.breakpoints.up('md'),
    UP_LG: theme.breakpoints.up('lg'),
    UP_XL: theme.breakpoints.up('xl'),
    DOWN_XS: theme.breakpoints.down('xs'),
    DOWN_SM: theme.breakpoints.down('sm'),
    DOWN_MD: theme.breakpoints.down('md'),
    DOWN_LG: theme.breakpoints.down('lg'),
    DOWN_XL: theme.breakpoints.down('xl'),
    ONLY_XS: theme.breakpoints.only('xs'),
    ONLY_SM: theme.breakpoints.only('sm'),
    ONLY_MD: theme.breakpoints.only('md'),
    ONLY_LG: theme.breakpoints.only('lg'),
    ONLY_XL: theme.breakpoints.only('xl'),
  };
};

export { default as useMediaQuery } from '@material-ui/core/useMediaQuery';
